import { useBackend } from "../../services";

export const useGetTagProducts = () => {
  const { get } = useBackend();
  const getTagProducts = () => get("products/tags");
  return { getTagProducts };
};
